import React from 'react';
import './RankingInt.css';

function RankingInt(props) {
	const { data, myorg } = props;
	if (!data?.length) {
		return null;
	}
	return (
		<div className="leaderboard-table">
			{data?.map((data)=>{
				return(
					<div
						className={'table-column ' + (myorg === data?.orgName ? 'self' : '')} key={data?.rank}>
						<div className="table-number">{data?.rank}</div>
						<div className="table-name">{data?.orgName}</div>
						<div className="table-point">{data?.unlockedCards}</div>
						<div className="table-point">{data?.points}</div>
					</div>
				)
			})}
		</div>
	);
}

export default RankingInt;

/*
<div className="RankingInt">
	{data?.map((data) => {
		return (
			<>
				<div key={data?.rank} className="RankingInt__Block">
					<div
						className={
							myorg == data?.orgName
								? 'RankingInt--rank'
								: 'RankingInt--rank-case2'
						}
					>
						{data?.rankImg ? <img src={data?.rankImg} /> : data?.rank}
					</div>
					<div
						className={
							myorg == data?.orgName
								? 'RankingInt--institute'
								: 'RankingInt--institute-case2'
						}
					>
						{data?.orgName.length > 25 ? data?.orgName.substr(0,25) + '...' : data?.orgName}
					</div>
					<div
						className={
							myorg == data?.orgName
								? 'RankingInt--points'
								: 'RankingInt--points-case2'
						}
					>
						{data?.points}
					</div>
				</div>
				<span className="RankingInt-line"></span>
			</>
		);
	})}
</div>*/
